import { sendNotification } from "../../APIs/NotificationsApis";
import { useState } from "react";
import { Button, message, Input } from "antd";
import "./styles.css";

const { TextArea } = Input;

const SendNotification = () => {
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");

  const [sendingLoading, setsendingLoading] = useState(false);

  const handleSendingMail = () => {
    setsendingLoading(true);
    sendNotification({ title, desc })
      .then((res) => {
        setsendingLoading(false);
        message.success(res?.data?.message ?? "تم الإرسال بنجاح");
        setTitle("");
        setDesc("");
      })
      .catch(async (error) => {
        setsendingLoading(false);
        let errorsArr = [];

        let errors = await error?.response?.data?.errors;
        errors.map((e) => {
          let error = e.field + " " + e.message;
          errorsArr.push(error);
        });
        message.error(errorsArr.join() ?? "حدث خطأ ما");
      });
  };

  return (
    <>
      {" "}
      <p className='privacy-top-txt mt-4 mr-4'>
        <span style={{ color: "rgba(151, 151, 151, 1)" }} className='mt-4'>
          لوحة التحكم /
        </span>{" "}
        <span> إرسال إشعار </span>
      </p>
      <div className='flex flex-col w-fit items-center justify-center mx-auto my-6 p-8 rounded-[5px] gap-8 bg-white '>
        <h1 className='text-2xl'>إرسال إشعار لجميع المستخدمين</h1>

        <div className='flex flex-col gap-2 w-[600px] max-w-[60vw]'>
          <label> العنوان </label>
          <input
            type='text'
            className='email-input'
            placeholder='عنوان الإشعار '
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          />
        </div>
        <div className='flex flex-col gap-2'>
          <label> المحتوي </label>
          <TextArea
            className='w-[600px] !h-[200px]  max-w-[60vw]'
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
          />
        </div>
        <Button
          className='sec-add-sec-modal-btn !w-[200px]  !-mt-2 disabled:!cursor-default'
          onClick={handleSendingMail}
          loading={sendingLoading}
          disabled={!desc || !title}
        >
          إرسال
        </Button>
      </div>
    </>
  );
};

export default SendNotification;
